import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Box } from "@material-ui/core"
import { ErrorBoundary } from "../ErrorBoundary"
import OfflineModeBanner from "../Offline/OfflineModeBanner"

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 20,
    fontSize: 20,
    fontWeight: "600 !important",
    lineHeight: "28px",
  },
}))

const InlineTitle = ({ children }) => {
  const classes = useStyles()

  return (
    <ErrorBoundary>
      <OfflineModeBanner />
      <Box className={classes.root} display="flex" alignItems="center" mx={2}>
        {children}
      </Box>
    </ErrorBoundary>
  )
}

export { InlineTitle }
